import { FetchError } from '../errors/FetchError'
import { fetchApiImageAuth2, fetchWithAuthorization } from './fetch'

export const findAllCoins = async (page = 1, limit = 5) => {
  try {
    const url = `/coins?page=${page}&limit=${limit}`
    const data = await fetchWithAuthorization(url)
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al consultar las monedas.')
  }
}

export const findAllExchangeRates = async (page = 1, limit = 5, params) => {
  const { coin } = params
  if (coin) {
    try {
      const url = `/history-coins/${coin}?page=${page}&limit=${limit}`
      const data = await fetchWithAuthorization(url)
      return data
    } catch (error) {
      throw new FetchError(error, 'Ha ocurrido un error al consultar las tasas de cambio.')
    }
  } else {
    throw new FetchError(null, 'Debes seleccionar una moneda.')
  }
}

export const createExchangeRate = async (params) => {
  const { currency, exchangeRate } = params
  try {
    const url = `/currency/exchange/${currency}`
    const data = await fetchWithAuthorization(url, exchangeRate, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al consultar los abonos.')
  }
}

export const createCoinsRate = async (params) => {
  const { currency, exchangeRate } = params
  try {
    const url = `/history-coins`
    const data = await fetchWithAuthorization(url, exchangeRate, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al consultar los abonos.')
  }
}

export const createCoin = async (datas) => {
  try {
    const data = await fetchWithAuthorization(
      "/coins",
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "Ha ocurrido un error al intentar crear una moneda."
    );
  }
};

export const createCurrency = async (params) => {
  const { currency } = params
  try {
    const url = '/currency'
    const data = await fetchWithAuthorization(url, currency, 'POST')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al crear la moneda.')
  }
}

export const updateCurrency = async (params) => {
  const { currency, id } = params
  try {
    const url = `/currency/${id}`
    const data = await fetchWithAuthorization(url, currency, 'PUT')
    return data
  } catch (error) {
    throw new FetchError(error, 'Ha ocurrido un error al actualizar la moneda.')
  }
}
